import { createContext, use, useEffect, useState } from "react";

export const WeekReflectionContext = createContext();

export const WeekReflectionContextProvider = ({ children }) => {
    const [weekReviewManager, setWeekReviewManager] = useState();
    const [textInputs, setTextInput] = useState({});
    const [reflectionId, setReflectionId] = useState();
    const [hasInputChanged, setInputChange] = useState(false);
    const [animateRewards, setAnimateRewards] = useState(true);

    const [lastStoryName, setLastStoryName] = useState('');
    const [handleRestart, setHandleRestart] = useState(() => { });

    const registerRestartStoriesFn = (fn) => {
        setHandleRestart(() => fn);
    }

    return (
        <WeekReflectionContext.Provider
            value={{
                reflectionId, setReflectionId,
                textInputs, setTextInput,
                weekReviewManager, setWeekReviewManager,
                hasInputChanged, setInputChange,
                animateRewards, setAnimateRewards,
                lastStoryName, setLastStoryName,
                handleRestart, registerRestartStoriesFn
            }}
        >
            {children}
        </WeekReflectionContext.Provider>
    );
};